import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { isLoading } from './loading.selectors';
import {
  animate,
  style,
  transition,
  state,
  trigger,
} from '@angular/animations';

@Component({
  selector:        'dx-loading',
  templateUrl:     './loading.component.html',
  styleUrls:       [ './loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations:      [
    // the fade-in/fade-out animation.
    trigger('fade', [
      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [style({ opacity: 0 }), animate(250)]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave', animate(600, style({ opacity: 0 }))),
    ]),
  ],
})
export class LoadingComponent {
  public isLoading$: Observable<boolean> = this.store$.pipe(select(isLoading));

  constructor(public store$: Store<any>) {}
}
